import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import SecondaryCta from 'base/components/SecondaryCta';
import { getVariantPrice } from 'menus/utils/cartModifications';
class CartItem extends React.Component {
  static propTypes = {
    quantity: PropTypes.number,
    name: PropTypes.string,
    variant: PropTypes.shape({
      price: PropTypes.string
    }),
    editCartItemPath: PropTypes.string,
    order_made_for: PropTypes.string,
    special_instructions: PropTypes.string,
    required_fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    remove: PropTypes.func,
    handleClose: PropTypes.func,
    currentCartPath: PropTypes.string
  };

  renderFields = () => {
    const { required_fields: fields } = this.props;
    return fields.map(field => (
      <ListItem
        key={field.slug}
        disableGutters
        dense
        style={{ display: 'block', padding: 0, lineHeight: 0 }}
      >
        <Typography component="span">{field.name}:</Typography>{' '}
        <List disablePadding dense style={{ display: 'inline' }}>
          {field.selected.map((option, idx, arr) => {
            const price = getVariantPrice(option.price_variance);
            return (
              <ListItem
                disableGutters
                dense
                key={option.option_slug}
                style={{ display: 'inline', padding: 0 }}
              >
                <Typography
                  component="span"
                  data-testid="cart-item-variant-name"
                >
                  {option.option_name}
                </Typography>{' '}
                {price && (
                  <Typography
                    component="span"
                    data-testid="cart-item-variant-price"
                  >
                    ($
                    {option.price_variance})
                  </Typography>
                )}
                {idx !== arr.length - 1 ? (
                  <Typography component="span">, </Typography>
                ) : (
                  ''
                )}
              </ListItem>
            );
          })}
        </List>
      </ListItem>
    ));
  };
  render() {
    const {
      quantity,
      name,
      variant,
      editCartItemPath,
      remove,
      order_made_for: orderMadeFor,
      special_instructions: specialInstructions,
      required_fields: fields,
      handleClose,
      currentCartPath
    } = this.props;

    return (
      <Box data-testid="cart-item" width="100%">
        <Box display="flex" justify="space-between" pt={2} pb={2}>
          <Box display="flex" alignContent="flex-start" flexBasis="30px">
            <Typography data-testid="cart-item-quantity">
              {quantity}x
            </Typography>
          </Box>
          <Box flex="2">
            <Typography color="textPrimary" data-testid="cart-item-name">
              {name}
            </Typography>
            {fields && !!fields.length && (
              <List disablePadding dense>
                {this.renderFields()}
              </List>
            )}
            {orderMadeFor && (
              <Typography data-testid="cart-item-made-for">
                Made For: {orderMadeFor}
              </Typography>
            )}
            {specialInstructions && (
              <Typography data-testid="cart-item-special-intructions">
                {specialInstructions}
              </Typography>
            )}
            <Box position="relative" left="-0.85rem">
              <SecondaryCta
                component={Link}
                to={{
                  pathname: editCartItemPath,
                  state: {
                    path: currentCartPath
                  }
                }}
                handleClick={handleClose}
                dataTestId="cart-item-edit-button"
                label="Edit"
              />

              <SecondaryCta
                handleClick={remove}
                dataTestId="cart-item-remove-button"
                label="Remove"
              />
            </Box>
          </Box>
          {variant && (
            <Box component={Grid} item display="flex" alignContent="flex-start">
              <Typography data-testid="cart-item-price">
                ${variant.price}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export default CartItem;
